<div class="account-deletion-container">
  <mat-card class="deletion-card">
    <mat-card-header>
      <div class="header-content">
        <img src="assets/images/Lenali_logo_Full.png" alt="Niaga Logo" class="app-logo">
        <mat-card-title>Suppression de compte Niaga</mat-card-title>
      </div>
    </mat-card-header>
    
    <mat-card-content>
      <div *ngIf="!hasSubmitted">
        <!-- Section d'introduction -->
        <div class="intro-section">
          <h2>Comment supprimer votre compte Niaga</h2>
          <p class="info-text">
            Cette page vous permet de demander la suppression de votre compte Niaga et de toutes vos données associées. 
            Cette action est définitive et ne peut pas être annulée.
          </p>
        </div>

        <!-- Section des données supprimées -->
        <div class="data-section">
          <h3>Données qui seront supprimées</h3>
          <div class="data-list">
            <div class="data-item">
              <mat-icon color="warn">delete</mat-icon>
              <span>Profil utilisateur et informations personnelles</span>
            </div>
            <div class="data-item">
              <mat-icon color="warn">delete</mat-icon>
              <span>Publications, commentaires et interactions</span>
            </div>
            <div class="data-item">
              <mat-icon color="warn">delete</mat-icon>
              <span>Messages privés et conversations</span>
            </div>
            <div class="data-item">
              <mat-icon color="warn">delete</mat-icon>
              <span>Photos et médias partagés</span>
            </div>
            <div class="data-item">
              <mat-icon color="warn">delete</mat-icon>
              <span>Stories et contenus temporaires</span>
            </div>
            <div class="data-item">
              <mat-icon color="warn">delete</mat-icon>
              <span>Préférences et paramètres du compte</span>
            </div>
          </div>

          <h3>Données conservées (si applicable)</h3>
          <div class="data-list">
            <div class="data-item">
              <mat-icon color="primary">info</mat-icon>
              <span>Données de facturation (conformément aux obligations légales)</span>
            </div>
            <div class="data-item">
              <mat-icon color="primary">info</mat-icon>
              <span>Logs de sécurité (conservés 30 jours pour la sécurité)</span>
            </div>
          </div>

          <div class="processing-time">
            <h3>Délai de traitement</h3>
            <p>Votre demande sera traitée dans un délai maximum de 30 jours ouvrables.</p>
          </div>
        </div>

        <!-- Section de procédure -->
        <div class="procedure-section">
          <h3>Procédure de suppression</h3>
          <div class="steps">
            <div class="step">
              <div class="step-number">1</div>
              <div class="step-content">
                <h4>Authentification</h4>
                <p>Identifiez-vous avec vos identifiants Niaga</p>
              </div>
            </div>
            <div class="step">
              <div class="step-number">2</div>
              <div class="step-content">
                <h4>Raison de suppression</h4>
                <p>Indiquez la raison de votre demande</p>
              </div>
            </div>
            <div class="step">
              <div class="step-number">3</div>
              <div class="step-content">
                <h4>Confirmation</h4>
                <p>Confirmez votre demande de suppression</p>
              </div>
            </div>
            <div class="step">
              <div class="step-number">4</div>
              <div class="step-content">
                <h4>Traitement</h4>
                <p>Nous traiterons votre demande sous 30 jours</p>
              </div>
            </div>
          </div>
        </div>
        
        <form [formGroup]="deletionForm" (ngSubmit)="onSubmit()">
          <!-- Section d'authentification (visible uniquement si l'utilisateur n'est pas connecté) -->
          <div *ngIf="!isAuthenticated" class="auth-section">
            <h3>Étape 1 : Identifiez-vous</h3>
            <p class="info-text">Veuillez vous identifier avec vos identifiants Niaga pour confirmer votre demande de suppression.</p>
            
            <mat-error *ngIf="authError" class="auth-error">
              {{ authError }}
            </mat-error>
            
            <mat-radio-group formControlName="authMethod" class="auth-method-group">
              <mat-radio-button value="email">S'authentifier avec un email</mat-radio-button>
              <mat-radio-button value="phone">S'authentifier avec un numéro de téléphone</mat-radio-button>
            </mat-radio-group>
            
            <!-- Champs d'authentification par email -->
            <mat-form-field appearance="outline" class="full-width" *ngIf="deletionForm.get('authMethod')?.value === 'email'">
              <mat-label>Email</mat-label>
              <input matInput type="email" formControlName="email">
              <mat-error *ngIf="deletionForm.get('email')?.hasError('required')">L'email est requis</mat-error>
              <mat-error *ngIf="deletionForm.get('email')?.hasError('email')">Veuillez entrer un email valide</mat-error>
            </mat-form-field>
            
            <!-- Champs d'authentification par téléphone -->
            <mat-form-field appearance="outline" class="full-width" *ngIf="deletionForm.get('authMethod')?.value === 'phone'">
              <mat-label>Numéro de téléphone</mat-label>
              <input matInput type="tel" formControlName="phoneNumber" placeholder="+33612345678">
              <mat-error *ngIf="deletionForm.get('phoneNumber')?.hasError('required')">Le numéro de téléphone est requis</mat-error>
              <mat-error *ngIf="deletionForm.get('phoneNumber')?.hasError('pattern')">Format de numéro invalide</mat-error>
            </mat-form-field>
            
            <!-- Mot de passe (commun aux deux méthodes) -->
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Mot de passe</mat-label>
              <input matInput type="password" formControlName="password">
              <mat-error *ngIf="deletionForm.get('password')?.hasError('required')">Le mot de passe est requis</mat-error>
              <mat-error *ngIf="deletionForm.get('password')?.hasError('minlength')">Le mot de passe doit contenir au moins 6 caractères</mat-error>
            </mat-form-field>
          </div>
          
          <h3>Étape 2 : Raison de la suppression</h3>
          
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Pourquoi souhaitez-vous supprimer votre compte Niaga ?</mat-label>
            <mat-select formControlName="reason">
              <mat-option *ngFor="let reason of deletionReasons" [value]="reason.value">
                {{ reason.label }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="deletionForm.get('reason')?.invalid">Ce champ est obligatoire</mat-error>
          </mat-form-field>
          
          <mat-form-field appearance="outline" class="full-width" *ngIf="deletionForm.get('reason')?.value === 'other'">
            <mat-label>Précisez la raison</mat-label>
            <textarea matInput formControlName="otherReason" rows="4"></textarea>
            <mat-error *ngIf="deletionForm.get('otherReason')?.invalid">Veuillez préciser la raison</mat-error>
          </mat-form-field>
          
          <h3>Email de contact (facultatif)</h3>
          <p class="info-text">
            Vous pouvez indiquer une adresse email pour que nous puissions vous contacter concernant votre demande.
          </p>
          
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Email de contact</mat-label>
            <input matInput type="email" formControlName="contactEmail">
            <mat-error *ngIf="deletionForm.get('contactEmail')?.invalid">Veuillez entrer une adresse email valide</mat-error>
          </mat-form-field>
          
          <div class="confirmation-section">
            <h3>Étape 3 : Confirmation finale</h3>
            <p class="warning-text">
              <mat-icon color="warn">warning</mat-icon>
              Cette action entraînera la suppression permanente de votre compte Niaga et de toutes les données associées. 
              Cette action ne peut pas être annulée.
            </p>
            
            <mat-checkbox formControlName="confirmation" color="primary">
              Je comprends que cette action est permanente et je souhaite supprimer mon compte Niaga et mes données.
            </mat-checkbox>
            <mat-error *ngIf="deletionForm.get('confirmation')?.invalid && deletionForm.get('confirmation')?.touched">
              Vous devez confirmer que vous souhaitez supprimer votre compte
            </mat-error>
          </div>
          
          <div class="button-container">
            <button type="button" mat-stroked-button routerLink="/home">Annuler</button>
            <button 
              type="submit" 
              mat-raised-button 
              color="warn" 
              [disabled]="!deletionForm.valid || isSubmitting">
              <mat-spinner diameter="20" *ngIf="isSubmitting"></mat-spinner>
              <span *ngIf="!isSubmitting">Demander la suppression de mon compte Niaga</span>
            </button>
          </div>
        </form>
      </div>
      
      <div *ngIf="hasSubmitted" class="success-message">
        <mat-icon color="primary">check_circle</mat-icon>
        <h2>Demande reçue</h2>
        <p>
          Votre demande de suppression de compte Niaga a été enregistrée avec succès. 
          Nous allons traiter votre demande dans un délai maximum de 30 jours ouvrables.
        </p>
        <p>
          Numéro de référence de votre demande : <strong>{{ requestId }}</strong>
        </p>
        <p>
          Si vous avez fourni une adresse email, nous vous contacterons à cette adresse pour vous informer de l'avancement de votre demande.
        </p>
        <div class="next-steps">
          <h3>Prochaines étapes</h3>
          <ul>
            <li>Nous examinerons votre demande sous 30 jours</li>
            <li>Vous recevrez une confirmation par email</li>
            <li>Vos données seront supprimées définitivement</li>
          </ul>
        </div>
        <button mat-raised-button color="primary" routerLink="/home">Retour à l'accueil</button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
